// AUTO GENERATED
// DO NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Icon = require("../lib/components/Icon");
const svg = require("../dist/svg/32/date-time-picker.svg");
const Component = (props) => {
    return (React.createElement(Icon.default, Object.assign({ }, props, { name: svg.default.id, size: 32 })));
};
Component.info = {
    id: svg.default.id,
    name: "date-time-picker",
    size: 32,
    getElement() {
        return svg.default.content.replace("<symbol", "<svg").replace("symbol>", "svg>");
    }
};
exports.default = Component;